/** @typedef {import('./Props').default} Props */

import React from 'react';
import SubscriptionPlans from '../../../../../shared/SubscriptionCheckout/SubscriptionPlans/SubscriptionPlans';
import tiers from '../../../../Agent/Subscription/Checkout/subscriptionTiersData';
import useGetGroupCheckoutLinks from '../../../../../Hooks/Admin/Getters/useGetGroupCheckoutLinks/useGetGroupCheckoutLinks';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export function Checkout(props) {
	const checkoutLinks = useGetGroupCheckoutLinks(
		props.groupId,
		!props.hasExistingSubscription
	);

	return (
		<section className="pt-6">
			<SubscriptionPlans
				checkoutRole="manager"
				groupId={props.groupId}
				hasExistingSubscription={props.hasExistingSubscription}
				isGettingData={
					props.hasExistingSubscription
						? false
						: checkoutLinks.isGettingData
				}
				paymentLinks={checkoutLinks.data}
				subscription={props.subscription}
				tiers={tiers}
			/>
		</section>
	);
}

export default Checkout;
